import React from 'react';

import { ModalComponent } from 'baseComponents/ModalComponent';

// Helpers
import { ButtonComponent } from 'baseComponents/ButtonComponent';
import './notEnougCreditsModal.scss';
import { TextComponent } from 'baseComponents/TextComponent';

export interface NotEnoughCreditsData {
  new_estimated_audience: number;
  current_credits: number;
  needed_credits: number;
}
interface Props<T> {
  onCancel: () => void;
  onAction: () => void;
  data?: T;
}

export const NotEnoughCreditsModal: React.FC<Props<NotEnoughCreditsData>> = (
  props
) => {
  return (
    <ModalComponent
      title='Insufficient Credits'
      close={props.onCancel}
      open={!!props.data}
      apperance='warning'
    >
      {props.data ? (
        <TextComponent
          text={`The new selected date results in ${props.data.new_estimated_audience} and your current credit balance is ${props.data.current_credits}. You need to purchase ${props.data.needed_credits} credits or cancel the rescheduling.`}
        />
      ) : null}

      <div className='not-enough-credits-btns'>
        <ButtonComponent
          appereance='secondary'
          size='middle'
          onClick={props.onCancel}
          label='Cancel'
          fullWidth
        />
        <ButtonComponent
          appereance='primary'
          size='middle'
          onClick={props.onAction}
          label='Purchase Credits'
          fullWidth
        />
      </div>
    </ModalComponent>
  );
};
